import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SLIDE_OFFSET = 25;

const OPTS = {
	start: 'top 90%',
	end: 'bottom 40%',
	toggleActions: 'play reverse play reverse',
	scrub: 4,
};

const ANIMATION_CONFIGS = [
	{
		selector: '.anim-slide-left',
		from: { xPercent: SLIDE_OFFSET, autoAlpha: 0 },
		to: { xPercent: 0, autoAlpha: 1, ease: 'power4.out' }
	},
	{
		selector: '.anim-slide-right',
		from: { xPercent: -SLIDE_OFFSET, autoAlpha: 0 },
		to: { xPercent: 0, autoAlpha: 1, ease: 'power4.out' }
	},
	{
		selector: '.anim-fade-up',
		from: { y: SLIDE_OFFSET, autoAlpha: 0 },
		to: { y: 0, autoAlpha: 1, ease: 'power4.out' }
	},
	{
		selector: '.anim-fade-down',
		from: { y: -SLIDE_OFFSET, autoAlpha: 0 },
		to: { y: 0, autoAlpha: 1, ease: 'power4.out' }
	}
];

const initGSAPElementAnimations = () => {
	ANIMATION_CONFIGS.forEach(({ selector, from, to }) => {
		document.querySelectorAll(selector).forEach((el) => {
			gsap.fromTo(el, from, {
				...to,
				scrollTrigger: {
					trigger: el,
					...OPTS,
				}
			});
		});
	});

	document.querySelectorAll('.anim-stagger-children').forEach((el) => {
		const children = Array.from(el.children);
		if (!children.length) return;

		gsap.fromTo(
			children,
			{ autoAlpha: 0, y: SLIDE_OFFSET },
			{
				autoAlpha: 1,
				y: 0,
				ease: 'power4.out',
				stagger: 0.15,
				scrollTrigger: {
					trigger: el,
					...OPTS,
					scrub:false,
					toggleActions: 'play none none none',
				}
			}
		);
	});

	document.querySelectorAll('.anim-parallax').forEach((el) => {
		gsap.to(el, {
			yPercent: -30,
			ease: 'none',
			scrollTrigger: {
				trigger: el,
				start: 'top bottom',
				end: 'bottom top',
				scrub: 1
			}
		});
	});
};

export { initGSAPElementAnimations };
